import {API_ROOT_URL} from 'envs/_current/config'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

import {schema} from 'normalizr'


export const dictionarySchema = new schema.Entity(
    'dictionaries',
    {},
    {
        idAttribute: 'idname'
    }
)
export const definitionSchema = new schema.Entity(
    'definitions',
    {},
    {
        idAttribute: 'id'
    }
)

// dictionary API

export const dictionary_createNew_Api = {
    backend: `// Route::post('dictionaries/dictionary/create-new', 'DictionaryController@create');`,
    root: API_ROOT_URL,
    path: '/dictionaries/dictionary/create-new',
    method: 'POST',
    schema: dictionarySchema,
    transform: createTransform(dictionarySchema, 'data'),
}

export const dictionary_update_Api = {
    backend: `// Route::post('dictionaries/dictionary/{id}/update', 'DictionaryController@update');`,
    root: API_ROOT_URL,
    path: '/dictionaries/dictionary/:id/update',
    method: 'POST',
    fields: ['title', 'description'],
    schema: dictionarySchema,
    transform: createTransform(dictionarySchema, 'data'),
}

export const dictionary_delete_Api = {
    backend: `// Route::post('dictionaries/dictionary/{id}/delete', 'DictionaryController@delete');`,
    root: API_ROOT_URL,
    path: '/dictionaries/dictionary/:id/delete',
    method: 'POST',
    schema: dictionarySchema,
    transform: createTransform(dictionarySchema, 'data'),
}

export const dictionary_createDefinition_Api = {
    backend: `// Route::post('dictionaries/{dictionary_id}/definition/create-new', 'DefinitionController@createDefinition');`,
    root: API_ROOT_URL,
    path: '/dictionaries/:dictionary_id/definition/create-new',
    method: 'POST',
    schema: definitionSchema,
    transform: createTransform(definitionSchema, 'data'),
}

export const dictionary_updateDefinition_Api = {
    backend: `// Route::post('dictionaries/definition/{definition_id}/update', 'DefinitionController@updateDefinition');`,
    root: API_ROOT_URL,
    path: '/dictionaries/definition/:definition_id/update',
    method: 'POST',
    fields: ['title', 'description'],
    schema: definitionSchema,
    transform: createTransform(definitionSchema, 'data'),
}

export const dictionary_deleteDefinition_Api = {
    backend: `// Route::post('dictionaries/definition/{definition_id}/delete', 'DefinitionController@deleteDefinition');`,
    root: API_ROOT_URL,
    path: '/dictionaries/definition/:definition_id/delete',
    method: 'POST',
    schema: definitionSchema,
    transform: createTransform(definitionSchema, 'data'),
}

export const dictionary_getById_Api = {
    backend: `// Route::get('dictionaries/dictionary/{id}/get', 'DictionaryController@getById');`,
    root: API_ROOT_URL,
    path: '/dictionaries/dictionary/:id/get',
    method: 'GET',
    schema: dictionarySchema,
    transform: createTransform(dictionarySchema, 'data'),
}

export const dictionary_getItems_Api = {
    name: 'dictionary_getItems_Api',
    backend: `// Route::get('dictionaries/dictionary/gets', 'DictionaryController@getItems');`,
    root: API_ROOT_URL,
    path: '/dictionaries/dictionary/gets',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword'],
    schema: dictionarySchema,
    transform: createListTransform(dictionarySchema),
}

// definition API

export const definition_getById_Api = {
    name: 'definition_getById_Api',
    backend: `// Route::get('definitions/definition/{id}/get', 'DefinitionController@getById');`,
    root: API_ROOT_URL,
    path: '/definitions/definition/:id/get',
    method: 'GET',
    schema: definitionSchema,
    transform: createTransform(definitionSchema),
}

export const definition_getDefinitionsByDictionary_Api = {
    name: 'definition_getDefinitionsByDictionary_Api',
    backend: `// Route::get('dictionaries/{dictionary_id}/definition/gets', 'DefinitionController@getDefinitionsByDictionary');`,
    root: API_ROOT_URL,
    path: '/dictionaries/:dictionary_id/definition/gets',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword'],
    schema: definitionSchema,
    transform: createListTransform(definitionSchema),
}

export const definition_getDefinitions_Api = {
    name: 'definition_getDefinitions_Api',
    backend: `// Route::get('definitions/gets', 'DefinitionController@getDefinitions');`,
    root: API_ROOT_URL,
    path: '/definitions/gets',
    method: 'GET',
    paramsFields: ['sort_by', 'keyword', 'start_with', 'dictionary', 'language'],
    schema: definitionSchema,
    transform: createListTransform(definitionSchema),
}

export const definition_getDefinitionsAsGlossary_Api = {
    name: 'definition_getDefinitionsAsGlossary_Api',
    backend: `// Route::get('definitions/gets-definitions-as-glossary', 'DefinitionController@getDefinitionsAsGlossary');`,
    root: API_ROOT_URL,
    path: '/definitions/gets-definitions-as-glossary',
    method: 'GET'
}

export const definition_getDefinitionsAsGlossaryForDictionary_Api = {
    name: 'definition_getDefinitionsAsGlossaryForDictionary_Api',
    backend: `// Route::get('dictionaries/{dictionary_id}/definitions/gets-definitions-as-glossary', 'DefinitionController@getDefinitionsAsGlossaryForDictionary');`,
    root: API_ROOT_URL,
    path: '/dictionaries/:dictionary_id/definitions/gets-definitions-as-glossary',
    method: 'GET'
}





